import React from "react";

export function DashboardContentSkeleton({ role = "athlete" }) {
  const isCoach = role === "coach";
  const columnCount = isCoach ? 2 : 3;

  return (
    <div
      className="space-y-4 w-full max-w-[1400px] mx-auto flex flex-col flex-1 min-h-0 animate-pulse"
      role="status"
      aria-label="Loading dashboard"
    >
      <div className="grid grid-cols-2 xl:grid-cols-4 gap-3 shrink-0">
        {Array.from({ length: 4 }, (_, index) => (
          <div
            key={index}
            className="h-16 rounded-xl border border-[color:var(--border)] bg-[var(--surface-1)]"
          />
        ))}
      </div>

      <div className={`grid grid-cols-1 gap-4 flex-1 min-h-0 ${
        isCoach ? "md:grid-cols-[1fr_2fr]" : "md:grid-cols-3"
      }`}>
        {Array.from({ length: columnCount }, (_, columnIndex) => (
          <div
            key={columnIndex}
            className="rounded-2xl border border-[color:var(--border)] bg-[var(--surface-1)] p-5 min-h-[380px] flex flex-col"
          >
            <div className="grid grid-cols-[1fr_auto_1fr] items-center gap-2 pb-3 border-b border-[color:var(--border)]">
              <div className="h-9 w-9 rounded-xl bg-[var(--surface-2)]" />
              <div className="h-5 w-24 rounded bg-[var(--surface-2)]" />
              <div className="justify-self-end h-9 w-9 rounded-xl bg-[var(--surface-2)]" />
            </div>
            <div className="mt-3 space-y-3">
              {Array.from({ length: 4 }, (_, rowIndex) => (
                <div
                  key={rowIndex}
                  className="rounded-2xl border border-[color:var(--border)] bg-[var(--surface-2)] px-4 py-4"
                >
                  <div className="flex items-center gap-3">
                    <div className="h-4 w-20 shrink-0 rounded bg-[var(--surface-1)]" />
                    <div className="min-w-0 flex-1 space-y-2">
                      <div className="h-4 w-3/4 rounded bg-[var(--surface-1)]" />
                      <div className="h-3 w-1/2 rounded bg-[var(--surface-1)]" />
                    </div>
                    <div className="h-6 w-12 shrink-0 rounded-full bg-[var(--surface-1)]" />
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export function AppShellLoadingSkeleton({ role }) {
  let resolvedRole = role;
  if (!resolvedRole && typeof window !== "undefined") {
    resolvedRole = window.localStorage.getItem("sp_dashboardRole") || "athlete";
  }

  return (
    <div className="bg-[var(--app-bg)] text-[var(--text)] h-screen overflow-hidden">
      <main className="h-full px-4 pt-4 pb-6 flex flex-col">
        <div className="mb-3 pb-2 flex gap-2 overflow-hidden animate-pulse" aria-hidden="true">
          {[120, 150, 150, 125, 130, 135, 150, 120].map((width, index) => (
            <div
              key={index}
              className="h-10 shrink-0 rounded-xl bg-[var(--surface-1)] border border-[color:var(--border)]"
              style={{ width }}
            />
          ))}
        </div>
        <DashboardContentSkeleton role={resolvedRole} />
      </main>
    </div>
  );
}
